import React, {Component, useEffect, useState} from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import connect from "react-redux/es/connect/connect";
import {
    getAutoclaveCiclos,
    getAutoclaveHistoricoIndicadores,
    getAutoclaves, getOSPorEtapaMaquinaCiclo
} from "../../../actions/autoclaveActions";
import AutoclaveLotarOSTabela from "./AutoclaveLotarOSTabela";
import AutoclaveCicloGraficoIndicadores from "./AutoclaveCicloGraficoIndicadores";
import AutoclaveCicloGraficoEventos from "./AutoclaveCicloGraficoEventos";
import AutoclaveCicloGraficoAlarmes from "./AutoclaveCicloGraficoAlarmes";
import AutoclaveCicloGraficoPresets from "./AutoclaveCicloGraficoPresets";
import AutoclaveCicloDistinctPresets from "./AutoclaveCicloDistinctPresets";
import {Paper} from "@material-ui/core";
import {getDadosPneus} from "../../../actions/tireActions";
import {useDispatch, useSelector} from "react-redux";
import {format, parseISO} from "date-fns";

const useStyles = makeStyles(theme => ({
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    newServiceOrderTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    leftMargin: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    relative: {
        position: 'relative'
    },
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: theme.spacing(1) * 10,
    },
    textCenter: {
        textAlign: 'center'
    },
    marginChart: {
        marginBottom: '20px'
    }
}));





const AutoclaveCicloSelecaoCiclo = (props) => {

    const classes = useStyles();

    const autoclaves = useSelector( state => state.autoclaves.Autoclaves );
    const ciclos = useSelector( state => state.autoclaves.AutoclaveCiclos );

    const [lAnos, setLAnos] = useState([]);
    const [lCiclos, setLCiclos] = useState([]);

    const [ano, setAno] = useState(new Date().getFullYear().toString());
    const [autoclaveCodigo,setAutoclaveCodigo] = useState(props.autoclaveCodigo);
    const [ciclo,setCiclo] = useState(props.ciclo);


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAutoclaveCiclos());
    }, []);

    useEffect(() => {
        setAutoclaveCodigo('');
    }, [ano]);

    useEffect(() => {

        setLAnos( [...new Set(ciclos.map(x => x.ano))]);
    }, [ciclos]);

    useEffect(() => {

        const ac = autoclaves.find( i => i.codigo === autoclaveCodigo * 1) ;
        if (typeof(ac) !== "undefined" && ac !== null) {
            const xano = ano * 1;
            const cf = ciclos.filter( c => c.autoclaveId === ac.id && c.ano === xano );
           setLCiclos(cf);
        } else { setCiclo('');}
    }, [autoclaveCodigo]);


    const onSubmit = () => {
        props.onSubmit(autoclaveCodigo, ciclo);
    }



        return (
            <div className={classes.textCenter}>
            <Typography variant="h6" align="center">
                <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="autoclave-label-placeholder" className={classes.relative}>
                        Ano
                    </InputLabel>
                    <Select
                        value={ano}
                        onChange={(e) => setAno(e.target.value)}
                        inputProps={{
                            name: 'ano',
                            id: 'ano-label-placeholder',
                        }}
                        displayEmpty
                        name="sano"
                        className={classes.selectEmpty}
                    >
                        {
                            (lAnos.length === 0) && <MenuItem value={new Date().getFullYear().toString()}>
                                                        {new Date().getFullYear().toString()}
                                            </MenuItem>
                        }
                        {
                            Array.isArray(lAnos) && lAnos.length > 0 &&
                            lAnos.map( i =>
                               <MenuItem key={i} value={i.toString()} >{i.toString()}</MenuItem>
                             )
                        }

                    </Select>

                </FormControl>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="autoclave-label-placeholder" className={classes.relative}>
                        Autoclave
                    </InputLabel>
                    <Select
                        value={autoclaveCodigo}
                        onChange={(e) => setAutoclaveCodigo(e.target.value)}
                        inputProps={{
                            name: 'autoclave',
                            id: 'autoclave-label-placeholder',
                        }}
                        displayEmpty
                        name="sautoclave"
                        className={classes.selectEmpty}
                    >
                        <MenuItem value="">
                            <em>Selecione</em>
                        </MenuItem>
                        {Array.isArray(autoclaves) && autoclaves.map( i =>
                           <MenuItem key={i.id} value={i.codigo} >{i.codigo}</MenuItem>

                        )}

                    </Select>

                </FormControl>

                <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="ciclo-label-placeholder" className={classes.relative}>
                        Ciclo
                    </InputLabel>
                    <Select
                        value={ciclo}
                        onChange={(e) => setCiclo(e.target.value)}
                        inputProps={{
                            name: 'ciclo',
                            id: 'ciclo-label-placeholder',
                        }}
                        displayEmpty
                        name="sciclo"
                        className={classes.selectEmpty}
                    >
                        <MenuItem key={'branco'} value="">
                            <em>Selecione</em>
                        </MenuItem>
                        {Array.isArray(lCiclos) &&

                        lCiclos
                            .map( i => {
                                let dt = "";
                                try {
                                    dt = format(parseISO(i.DTInicio), "yyyy-MM-dd")
                                }catch  {}

                              return(   <MenuItem key={i.id}
                                          value={i.ciclo}>{i.ciclo} - {dt}</MenuItem>)
                            }

                        )}

                    </Select>
                </FormControl>

                <Button
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                     onClick={onSubmit}
                >
                    Pesquisar
                    <SearchIcon className={classes.leftMargin}  />
                </Button>
            </Typography>
            </div>
        )





}





export default AutoclaveCicloSelecaoCiclo;
